import {combineReducers} from '@reduxjs/toolkit';
import {combineEpics} from 'redux-observable';
import {catchError} from 'rxjs/operators';

import type {WikiEpic} from './types';

import {reducer as globalReducer} from './slices/global';
import {reducer as userReducer} from './slices/user';
import {reducer as searchReducer, epic as searchEpic} from './slices/search';
import {reducer as hiThereReducer, epic as hiThereEpic} from './slices/hi-there';
import {reducer as userSettingsReducer} from './slices/user-settings';
import {
    reducer as asyncOperationsReducer,
    epic as asyncOperationsEpic,
} from './slices/async-operations';

import {
    reducer as clustersReducer,
    epic as clustersEpic,
    actions as clusterActions,
} from './slices/clusters';

import {reducer as pagesReducer, epic as pagesEpic} from './slices/pages';

import {reducer as inviteReducer} from './slices/invite';
import {reducer as commentsReducer} from './slices/comments';
import {reducer as subscribersReducer} from './slices/subscribers';

import {reducer as usersReducer} from './slices/users';

import {favoritesEpic, reducer as favoritesReducer} from './slices/panels/favorites';
import {reducer as autoBookmarksReducer, autoBookmarksEpic} from './slices/panels/autobookmarks';
import {reducer as subscriptionsReducer, subscriptionsEpic} from './slices/panels/subscriptions';
import {reducer as recoveryTokens, recoveryTokensEpic} from './slices/panels/recovery-tokens';

import {reducer as navigationTreeReducer} from './slices/navigation-tree';
import {reducer as userFeaturesReducer} from './slices/user-features';
import {reducer as groupsReducer} from './slices/groups';
import {reducer as departmentsReducer} from './slices/departments';
import {reducer as backgroundsReducer} from './slices/backgrounds';
import {reducer as revisionsReducer} from './slices/revisions';
import {reducer as attachmentsReducer} from './slices/attachments';

import {reducer as msDocReducer, epic as msDocEpic} from './slices/ms-doc';

export {clusterActions};

export const rootReducer = combineReducers({
    global: globalReducer,
    user: userReducer,
    search: searchReducer,
    hiThere: hiThereReducer,
    asyncOperations: asyncOperationsReducer,
    clusters: clustersReducer,
    userSettings: userSettingsReducer,
    pages: pagesReducer,
    invite: inviteReducer,
    users: usersReducer,
    favorites: favoritesReducer,
    autoBookmarks: autoBookmarksReducer,
    subscriptions: subscriptionsReducer,
    comments: commentsReducer,
    subscribers: subscribersReducer,
    navigationTree: navigationTreeReducer,
    msDoc: msDocReducer,
    userFeatures: userFeaturesReducer,
    groups: groupsReducer,
    departments: departmentsReducer,
    backgrounds: backgroundsReducer,
    revisions: revisionsReducer,
    attachments: attachmentsReducer,
    recoveryTokens: recoveryTokens,
});

export const rootEpic: WikiEpic = (...args) =>
    combineEpics(
        searchEpic,
        hiThereEpic,
        asyncOperationsEpic,
        clustersEpic,
        pagesEpic,
        favoritesEpic,
        autoBookmarksEpic,
        recoveryTokensEpic,
        subscriptionsEpic,
        msDocEpic,
    )(...args).pipe(
        catchError((error, source) => {
            console.error(error);
            // Если произошла неведомая ошибка,
            // ПЕРЕЗАПУСКАЕМ source в котором она произошла
            return source;
        }),
    );
